import { Flex } from 'antd';
import Navbar from './navbar';
import TopSection from './top-section';
import BenefitsSection from './benefits-section';
import MiddleSection from './middle-section';
import SignupSection from './signup-section';
import TrustSection from './trust-section';
import StoriesSection from './stories-section';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentTenant } from 'reducers/selectors';

const LandingPage = () => {
  const signupRef = useRef(null);
  const { tenantData } = useSelector(selectCurrentTenant);

  return (
    <Flex vertical>
      <Navbar />
      <TopSection signupRef={signupRef} />
      <MiddleSection />
      <SignupSection signupRef={signupRef} />
      <BenefitsSection />
      <TrustSection />
      <StoriesSection />
      <Flex justify="center" align="center">
        <a
          href="https://www.legitscript.com/websites/?checker_keywords=joinelevate.com"
          target="_blank"
          rel="noopener noreferrer"
          title="Verify LegitScript Approval for www.joinelevate.com"
        >
          <img
            src="https://static.legitscript.com/seals/20829420.png"
            alt="Verify Approval for www.joinelevate.com"
            width="73"
            height="79"
          />
        </a>
      </Flex>
      <div
        style={{ color: '--user-main-text-2', paddingInline: '24px' }}
        className="body-14-medium text-align-center my-3"
      >
        {tenantData?.copyright_notice}
      </div>
    </Flex>
  );
};

export default LandingPage;
